/**
 *
 * @param {string} str
 * @returns {*}
 */
export function kebabToCamel(str) {
  return str.replace(/(-\w)/g, m => m[1].toUpperCase());
}

/**
 *
 * @param {string} str
 * @returns {string}
 */
export function pascalToKebab(str) {
  return str.replace(/[\w]([A-Z])/g, m => m[0] + '-' + m[1]).toLowerCase();
}

/**
 *
 * @param {string} str
 * @returns {string}
 */
export function kebabToPascal(str) {
  return ucFirst(kebabToCamel(str));
}

/**
 *
 * @param {String} str
 * @returns {string}
 */
export function ucFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 *
 * @param {string} str
 * @returns {string}
 */
export function ucWords(str) {
  return Array.from(str).reduce((acc, char, i) => {
    if (i === 0 || str.charAt(i - 1) === ' ' || str.charAt(i - 1) === '-') {
      return acc + char.toUpperCase();
    }

    return acc + char;
  }, '');
}

/**
 *
 * @returns {string}
 */
export function randomStr() {
  return Math.random().toString(36).substring(2);
}
